module.exports = __webpack_public_path__ + "static/media/svg-sprite.ff73bfdc.svg";